import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  FlatButton as MuiFlatButton,
  Dialog as MuiDialog,
  RadioButton as MuiRadioButton,
  RadioButtonGroup as MuiRadioButtonGroup
} from 'material-ui';
import styles from '../../../shared-styles';
import { scienceBlue } from '../../../theme/colors';
import './shared-styles.css';
import modalStyles from './modal-styles';

export const Actions = ({ cancelValidation }) => {
  return (
    <div className="actions-container">
      <MuiFlatButton
        label="Cancel"
        labelStyle={{
          color: scienceBlue,
          fontFamily: 'proxima-nova',
          fontWeight: 600,
          letterSpacing: '0.05rem'
        }}
        onClick={ cancelValidation }
        className="button-cancel"
        hoverColor="transparent"
        rippleColor="transparent"
      />
    </div>
  );
};

Actions.propTypes = {
  cancelValidation: PropTypes.func.isRequired
};

const getLabel = (address) => {
  return Object.keys(address).map(k => address[k]).filter(str => str).join(', ');
};

export const DialogContent = ({ verifyResults, pickAddress }) => {
  return (
    <div>
      <h4>Please choose your correct address:</h4>
      <MuiRadioButtonGroup name="addressOptions" onChange={ pickAddress }>
        { verifyResults.map(option => <MuiRadioButton key={ option.candidateIndex } className="pick-address-row" value={ option.address } label={ getLabel(option.address) } />)}
      </MuiRadioButtonGroup>
    </div>
  );
};

DialogContent.propTypes = {
  verifyResults: PropTypes.array.isRequired,
  pickAddress: PropTypes.func.isRequired
};

class PickAddress extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleError = (error) => {
    this.setState({ error });
  }

  pickAddress = async (ev, address) => {
    try {
      await this.props.onAddressVerified(address);
    } catch (err) {
      this.handleError(err.message);
    }
  }

  render() {
    return (
      <MuiDialog
        title="Pick Address"
        actions={ <Actions { ...this.props } /> }
        titleStyle={ modalStyles.title }
        bodyStyle={ modalStyles.content }
        contentStyle={ modalStyles.modal }
        open
      >
        <DialogContent { ...this.props } pickAddress={ this.pickAddress } />
        { this.state.error
          ? <p className="error-text" style={ styles.errorStyle }>{ this.state.error }</p>
          : null
        }
      </MuiDialog>
    );
  }
};

PickAddress.propTypes = {
  cancelValidation: PropTypes.func.isRequired,
  verifyResults: PropTypes.array.isRequired,
  onAddressVerified: PropTypes.func.isRequired
};

export default PickAddress;
